import { CHAT_MESSAGE_PADDING_HORIZONTAL } from '@fruitful/agent-ui';
import { useState } from 'react';
import { BodyMediumRegular, View, XStack, YStack } from 'smoothie';

import { useCharacterTypewriter } from '../../hooks/useTypewriter';
import { CHAT_USER_BUBBLE } from './ChatLayout';

interface UserMessageBubbleProps {
    text: string;
    isError?: boolean;
    /** Types the text in character-by-character instead of showing it immediately — used for the member's carousel pick. */
    typewriter?: boolean;
    /** Holds the typewriter at 0 characters until true. Ignored when `typewriter` is false. */
    typewriterEnabled?: boolean;
}

export const UserMessageBubble = ({
    text,
    isError = false,
    typewriter = false,
    typewriterEnabled = true,
}: UserMessageBubbleProps) => {
    const { visibleText: typedText } = useCharacterTypewriter({
        text,
        enabled: typewriter && typewriterEnabled,
    });
    const visibleText = typewriter ? typedText : text;

    const [measuredHeight, setMeasuredHeight] = useState<number | null>(null);

    const textColor = isError ? '$red1100' : '$black';
    const backgroundColor = isError
        ? '$red200'
        : CHAT_USER_BUBBLE.backgroundColor;

    return (
        <XStack
            width="100%"
            justifyContent="flex-end"
            paddingHorizontal={CHAT_MESSAGE_PADDING_HORIZONTAL}
        >
            {typewriter && (
                <View
                    position="absolute"
                    opacity={0}
                    pointerEvents="none"
                    onLayout={(event) => {
                        const height = event.nativeEvent.layout.height;
                        setMeasuredHeight((previous) =>
                            previous === height ? previous : height,
                        );
                    }}
                >
                    <YStack
                        paddingHorizontal={CHAT_USER_BUBBLE.paddingHorizontal}
                        paddingVertical={CHAT_USER_BUBBLE.paddingVertical}
                    >
                        <BodyMediumRegular>{text}</BodyMediumRegular>
                    </YStack>
                </View>
            )}
            <YStack
                backgroundColor={backgroundColor}
                borderRadius={CHAT_USER_BUBBLE.borderRadius}
                paddingHorizontal={CHAT_USER_BUBBLE.paddingHorizontal}
                paddingVertical={CHAT_USER_BUBBLE.paddingVertical}
                flexShrink={1}
                height={
                    typewriter && measuredHeight != null
                        ? measuredHeight
                        : undefined
                }
            >
                <BodyMediumRegular color={textColor}>
                    {visibleText}
                </BodyMediumRegular>
            </YStack>
        </XStack>
    );
};
